
export function getCognitoIdentityProviderName(authRegion: string, userPoolId: string) {
  return `cognito-idp.${authRegion}.amazonaws.com/${userPoolId}`;
}

// TODO: once #11426 has been deployed, this function can be replaced by direct usage
//       of serviceDocument.clientConfig.cognitoEndpoint since it would always be defined
export function getOpenIdConnectProviderUrl(authRegion: string, userPoolId: string, cognitoEndpoint: string | undefined) {
  return cognitoEndpoint ?? 'https://' + getCognitoIdentityProviderName(authRegion, userPoolId);
}
